import { PureComponent } from "react";

import { Timestamp } from "../shared/Timestamp";
import { UserAvatar } from "../shared/UserAvatar";

import { UnreadBadge } from "./UnreadBadge";

interface User {
  account: string;
  avatarSrc1x: { url: string };
  avatarSrc2x: { url: string };
}

interface Props {
  sender: User;
  state: string;
  messageHtml: string;
  sourcePath: string;
  updatedAt: any;
}

export class NotificationItem extends PureComponent<Props> {
  render() {
    const sender = this.props.sender;
    return (
      <li>
        <a href={this.props.sourcePath} className="notificationCenter-notification">
          <div className="notificationItem__content__icon">
            <UnreadBadge unread={this.props.state === "UNREAD"} />
            <UserAvatar
              user={{
                account: sender.account,
                avatar1x: { url: sender.avatarSrc1x.url },
                avatar2x: { url: sender.avatarSrc2x.url },
              }}
              size="medium"
              isLink={false}
            />
          </div>
          <div className="notificationCenter-notificationBody">
            <div className="notificationCenter-message">
              <span dangerouslySetInnerHTML={{ __html: this.props.messageHtml }} />
            </div>
            <div className="notificationCenter-updatedAt">
              <Timestamp value={this.props.updatedAt} />
            </div>
          </div>
        </a>
      </li>
    );
  }
}
